import { render } from "./MFITTIndexThumbnailDisp.vue?vue&type=template&id=32f2be8f"
import script from "./MFITTIndexThumbnailDisp.vue?vue&type=script&lang=js"
export * from "./MFITTIndexThumbnailDisp.vue?vue&type=script&lang=js"

import "./MFITTIndexThumbnailDisp.vue?vue&type=style&index=0&id=32f2be8f&lang=scss"
script.render = render

export default script